import { createStore, applyMiddleware } from 'redux';
import { createHashHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import rootReducer from '../reducers';

export const history = createHashHistory();

const composeEnhancers = composeWithDevTools({});

const createStoreWithMiddleware = composeEnhancers(
  applyMiddleware(routerMiddleware(history), thunk),
)(createStore);

history.listen((location) => {
  if (window.ga && typeof window.ga === 'function') {
    window.ga('set', 'page', location.pathname + location.search);
    window.ga('send', 'pageview');
  }
});

export default function configureStore(initialState = {}) {
  return createStoreWithMiddleware(
    connectRouter(history)(rootReducer),
    initialState,
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js